import { features } from 'reactApp/mail-features';

const defaultList = [
    'W2TB_1h_overquota_exit_v1',
    'W2TB_1d_overquota_exit_v1',
    'W2TB_7d_overquota_exit_v1',
    'W2TB_1h_overquota_exit_v2',
    'W2TB_1d_overquota_exit_v2',
    'W2TB_7d_overquota_exit_v2',
    'W2TB_1h_overquota_exit_v3',
    'W2TB_1d_overquota_exit_v3',
    'W2TB_7d_overquota_exit_v3',
    'W2TB_1h_overquota_exit_v4',
    'W2TB_1d_overquota_exit_v4',
    'W2TB_7d_overquota_exit_v4',
];
const transactPaymentTariffsList = features.getAsArray('transact-payment-tariffs-list', defaultList);

export const allTransactPaymentTariffsList = [...new Set([...defaultList, ...transactPaymentTariffsList])];
